import React from "react";
import "./HairSalonInLavelleCustomer.css";
const HairSalonInLavelleCustomer = () => {
  return (
    <div className="hairSalonInLavelleCustomer">
      <h5>
        Testimonials: What Our Clients Say About SCENT Hair Salon in Lavelle
        Road
      </h5>
      <p>
        Don’t just take our word for it – hear what our clients have to say
        about their experiences at SCENT Hair & Beauty Salon. Our reputation as
        the top hair salon in Lavelle Road is built on the positive feedback
        from our satisfied clients.
      </p>
      <div className="hairSalonInLavelleCustomerContent">
        <p>
          <span className="quote">“</span>I’ve been going to SCENT for over a
          year now, and I wouldn’t trust anyone else with my hair. The stylists
          are incredibly talented, and the service is always top-notch. Best
          hair salon in Lavelle Road by far! <span className="quote">”</span> -{" "}
          <span>Aarti S. </span>
        </p>
        <p>
          <span className="quote">“</span>SCENT Hair & Beauty Salon is my go-to
          for all things hair. From cuts to color, they always get it right. The
          ambiance is so relaxing – it’s a true escape. Highly recommend this
          hair salon in Lavelle Road!
          <span className="quote">”</span> - <span>Rohan M . </span>
        </p>
        <p>
          <span className="quote">“</span>I had my bridal hair and makeup done
          at SCENT, and it was perfect! The team listened to exactly what I
          wanted and made me feel like a queen on my big day. Best decision ever
          to choose this hair salon in Lavelle Road.
          <span className="quote">”</span> - <span>Priya K . </span>
        </p>
      </div>
    </div>
  );
};

export default HairSalonInLavelleCustomer;
